import { useEffect, useImperativeHandle, useRef, useState } from "react";
import ReactPlayer from "react-player";
import useVideo from "../../hooks/useVideo";
import { getSeconds, getSequence } from "../../utils/functions";
import useSlice from "../../hooks/useSlice";
import { useSelector } from "react-redux";
import { SCREENS } from "@educaplay/store/constants";

const PROGRESS_INTERVAL = 500;
export function VideoPlayer(props) {

    const { onChangeProgress, currentSequence } = props;
    const { ref, playing, setPlaying, sequences, progress, setProgress } = useVideo();
    const { showSlice, currentQuestionTimeAppear, currentQuestion } = useSlice();
    const [hasSeekTo, setHasSeekTo] = useState(false);
    const videoRef = useRef(null);
    const view = useSelector(state => state.game.view);
    const [chargeVideo, setChargeVideo] = useState(true);
    const subtitle = currentQuestion.subtitle;

    useEffect(() => {
        if (view === SCREENS.GAME) return;
        setPlaying(false);
    }, [view, setPlaying])

    useEffect(() => {
        onChangeProgress(progress);
    }, [progress, onChangeProgress])

    useEffect(() => {
        seekTo(progress);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentSequence.id])


    useEffect(() => {
        setHasSeekTo(false);
        setChargeVideo(true);
    }, [currentSequence.video])

    useImperativeHandle(ref, () => {
        return {
            seekTo: (progress) => {
                setProgress(progress);
                const secuence = getSequence(sequences, progress);
                const secondSeekTo = getSeconds(secuence, progress);
                videoRef.current.seekTo(secondSeekTo);
            }
        }
    }, [sequences, setProgress])

    useEffect(() => {
        if (currentQuestionTimeAppear !== progress || !showSlice) return;
        setPlaying(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentQuestionTimeAppear, progress, showSlice])

    const onProgressHandler = (state) => {
        if (!playing) return;
        const { playedSeconds } = state;
        const playedSecondsFormatted = Math.floor(playedSeconds);
        const difference = Math.max(playedSecondsFormatted - currentSequence.secondStart, 0)
        const currentProgress = difference + currentSequence.timeAppear;
        if (progress > currentProgress || currentProgress - progress > 1 || playedSecondsFormatted < currentSequence.secondStart) {
            ref.current.seekTo(progress + 1)
            return
            //TODO: implementar solucion para que funcione tambien en Twitch de una manera correcta (el progress alguna vez llega de dos en dos segundos)
        }
        setProgress(currentProgress);
    }
    const seekTo = (progress) => {
        const secuence = getSequence(sequences, progress);
        const secondSeekTo = getSeconds(secuence, progress);
        videoRef.current.seekTo(secondSeekTo);
    }
    return (
        <ReactPlayer
            width="100%"
            height="100%"
            ref={videoRef}
            url={currentSequence.video}
            playing={chargeVideo || playing}
            onEnded={() => ref.current.seekTo(progress + 1)}
            onProgress={onProgressHandler}
            onReady={() => {
                if (hasSeekTo) return;
                seekTo(progress)
                setHasSeekTo(true);
            }}
            onStart={() => {
                setTimeout(() => {
                    setChargeVideo(false)
                }, 200);
            }}
            playsinline
            onPlay={() => { if (!chargeVideo) setPlaying(true) }}
            onPause={() => setPlaying(false)}
            controls={false}
            progressInterval={PROGRESS_INTERVAL}
            muted={chargeVideo}
            config={{
                youtube: {
                  playerVars: { cc_load_policy: subtitle.show ? 1:0 ,hl: subtitle.lang}
                }
              }}
        />
    )

}
